import { useState, useCallback } from 'react';

let addToastGlobal = null;
let updateToastGlobal = null;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((msg, type = 'success') => {
    const id = Date.now() + Math.random(); // avoid collisions within the same ms
    setToasts(prev => [...prev, { id, msg, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
    return id;
  }, []);

  // Update an existing toast in place (message and/or type). Used to turn a
  // "working…" toast into its result without stacking a second popup.
  const updateToast = useCallback((id, msg, type) => {
    setToasts(prev => prev.map(t =>
      t.id === id ? { ...t, msg, ...(type ? { type } : {}) } : t));
  }, []);

  addToastGlobal = addToast;
  updateToastGlobal = updateToast;

  return { toasts, addToast };
}

// Returns the toast id so callers can update it later.
export function toast(msg, type = 'success') {
  return addToastGlobal ? addToastGlobal(msg, type) : null;
}

export function updateToast(id, msg, type) {
  if (updateToastGlobal && id != null) updateToastGlobal(id, msg, type);
}

export function ToastContainer({ toasts }) {
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>{t.msg}</div>
      ))}
    </div>
  );
}
